<template>
    <div class="page-layout__heading">
        <div class="page-layout__heading-inner">
            <div v-if="$store.getters['heading/getHeadings'].toBack.label" class="page-layout__back-btn">
                <router-link :to="$store.getters['heading/getHeadings'].toBack.route.name === $store.getters['route/getLastRoute'].name ? $store.getters['route/getLastRoute'] : $store.getters['heading/getHeadings'].toBack.route" class="btn  btn--with-icon  p-0  m-0">
                    <svg class="btn__icon">
                        <use xlink:href="#icon__arrow-2-left"></use>
                    </svg>
                    {{ $store.getters['heading/getHeadings'].toBack.label }}
                </router-link>
            </div>
            <div v-if="$store.getters['heading/getBreadcrumbs'].length > 0" class="breadcrumbs">
                <ul class="breadcrumbs__list">
                    <li v-for="bread in $store.getters['heading/getBreadcrumbs']" class="breadcrumbs__item">
                        <router-link v-if="bread.route" :to="bread.route" class="breadcrumbs__link">{{ bread.label }}</router-link>
                        <span v-if="bread.route" class="breadcrumbs__separator"></span>
                        <span v-else class="breadcrumbs__item breadcrumbs__item--current">{{  bread.label }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="page-layout__heading-inner">
            <div class="d-flex  align-items-center">
                <h1 class="page-layout__title">{{ $store.getters['heading/getTitle'] }}</h1>
                <span v-if="$store.getters['heading/getAppInfo'].id && $route.name==='api.application.get'" :class="{'badge--success' : $store.getters['heading/getAppInfo'].status==='NEW', 'badge--accent' : $store.getters['heading/getAppInfo'].status==='REJECTED'}"
                      class="page-layout__title-badge badge ml-2">{{getTranslation('APPLICATION_'+$store.getters['heading/getAppInfo'].status)}}</span>
            </div>
            <div v-if="$store.getters['heading/getActions'].length > 0" class="page-layout__heading-filler"></div>
            <div v-if="$store.getters['heading/getActions'].length > 0" class="page-layout__controls">
                <span v-for="(action, idx) in $store.getters['heading/getActions']" v-bind:key="idx" class="ml-3">
                    <router-link v-if="action.route" :to="action.route" :class="'btn  btn--white  btn--system' + (action.icon ? ' btn--with-icon' : '')">
                        <svg v-if="action.icon" :class="'btn__icon ' + (action.icon.classes || '')"><use :xlink:href="action.icon.icon"></use></svg>
                        {{ action.label }}
                    </router-link>
                    <button v-if="action.action" @click="action.action" type="button" :class="'btn  btn--white  btn--system' + (action.icon ? ' btn--with-icon' : '')">
                        <svg v-if="action.icon" :class="'btn__icon ' + (action.icon.classes || '')"><use :xlink:href="action.icon.icon"></use></svg>
                        {{ action.label }}
                    </button>
                </span>
            </div>
            <div v-if="$route.name==='api.home' && $store.getters['heading/getFilterOptions'].length > 0" class="page-layout__controls">
                <select class="page-layout__day-switcher" v-model="filter">
                    <option v-for="item in $store.getters['heading/getFilterOptions']" v-bind:value="item.id">
                        {{ item.title }}
                    </option>
                </select>
            </div>
        </div>
        <div v-if="$store.getters['heading/getAppInfo'].id && $route.name==='api.application.get'" class="page-layout__page-descr">
            <div v-if="$store.getters['heading/getAppInfo'].isRejected" class="text  text--danger">
                {{ $store.getters['heading/getAppInfo'].comment }}
            </div>
            <div v-if="$store.getters['heading/getAppInfo'].office && $store.getters['heading/getAppInfo'].date" class="text  text--grey">
                  {{ getTranslation('whereTooksPart') }}
                <span @click="gotoOfficeView($store.getters['heading/getAppInfo'].officeId)" style="cursor: pointer" class="font-weight-bold" :class="{'color-accent': !$store.getters['heading/getAppInfo'].isRejected}">
                  {{ getTranslation('office') }} {{ $store.getters['heading/getAppInfo'].office }}
                </span>. {{ getTranslation('when') }}: <span class="font-weight-bold" :class="{'color-accent': !$store.getters['heading/getAppInfo'].isRejected}">{{ $store.getters['heading/getAppInfo'].date }}</span>
            </div>
          <div v-if="$store.getters['heading/getAppInfo'].isTrial"  class="text text--bold  text--danger">
            {{ getTranslation('appType_proba') }}
          </div>
        </div>
    </div>
    <!-- /page-layout__head -->
</template>

<script>
    export default {
        name: "AdminHeading",
        computed: {
            filter: {
                get() {
                    return this.$store.getters['heading/getFilter'];
                },
                set( val ) {
                    this.$store.commit( 'heading/SET_FILTER', val );
                }
            }
        },
        methods: {
            gotoOfficeView( officeId ) {
                this.$router.push( { name: 'api.office.get', params: { id: officeId } } )
                    .catch( () => {
                    } );
            }
        }
    }
</script>

<style scoped>

</style>
